import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ProjectForm from '../Form';
import { createProject } from '@resources/Project/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createProject, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createProject(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.project.create',
						defaultMessage:
							'A new Project has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.project',
					defaultMessage: 'Create Project',
				})}
			</Title>
			<ProjectForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createProject })(Create);
